import { ApplicationElement, html } from '@effectivastudio/lit-components';
import { ifDefined } from 'lit/directives/if-defined.js';
import '@effectivastudio/lit-components/components/icon_block/element.js';
import style from './style.lit.css';

/**
 * Link element with an icon and slot element for text.
 *
 * @prop icon Navigation item's icon name
 * @prop href - Link's destination url
 * @prop target - <a> tag's target property - where the browser should open the link (options: /, _blank, _parent, _self, _top)
 * @prop active - Indicates activated navigation item
 * @prop turbolinksAction - Link data-remote action (optional)
 * @prop remote - Add data-remote="true" to link (optional)
 *
 * @slot default - For navigation item text
 *
 * @cssprop --background-color - Component's background color
 * @cssprop --color - Component's font color
 * @cssprop --icon-font-size-primary - Icon size
 * @cssprop --font-size-primary - Font size
 * @cssprop --min-width - Component's min width
 * @cssprop --el-border-radius - Component's border radius
 */

export default class NavigationItem extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    icon: { type: String },
    href: { type: String },
    target: { type: String },
    active: { type: Boolean },
    turbolinksAction: { type: String },
    remote: { type: Boolean },
  };

  connectedCallback() {
    super.connectedCallback();
    this.active = this.activateByCurrentLink();
  }

  render() {
    return html`
      <a
        data-turbolinks-action=${ifDefined(this.turbolinksAction)}
        data-remote=${ifDefined(this.remote)}
        href=${this.href}
        active=${this.active}
        target=${ifDefined(this.target)}>
        <ef-icon-block icon=${this.icon}>
          <slot></slot>
        </ef-icon-block>
      </a>
    `;
  }
}

customElements.get('xs-nav-item') ||
  customElements.define('xs-nav-item', NavigationItem);
